module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAORJREFUOE+tk00OgjAQhV/9uYeeBDiJcAcwmRVh1YRyB/UkcBPxHGpqGAELBcRgV81k5uubN1OBhUcsrMcHIFMfdDz/CjQAKgdFXgcglQuKCiuGRwmisooPA6TcAZtTXViAooTvUsWA8IG7Nw5ok3TAr8usBukdIEpQGJiKugqgL8DK6SdBqhxAYrUz2kLzRKWmkc8tcGsHM/bFxOwKCvet5MYbw2wbwElrl0cqawD7om/As2BzpwHKBeCwzP8BUv/dRqVgG5sm96Yw7PTUdhqAzvLM2Wgeq/2Z2MQZx1rlGTVDKS+KW3sRpczMbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/baobiaozhongxin.png
// module id = 3KFt
// module chunks = 1